export default __webpack_public_path__ + "static/5-5e53dbead7acb3f20eaf9817afa1c2ce.jpeg";